import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Select} from 'antd'

@inject('store') @observer
class Commission extends Component {
  handleChange = (value) => {
    const {backtest} = this.props.store
    if (value === '') {
      backtest.single.change('commission', null)
    } else {
      backtest.single.change('commission', {id: parseInt(value)})
    }
  }
  render() {
    const {backtest} = this.props.store
    const {commission} = backtest.single.data
    return(
      <div>
        <label>Commission</label>
        <Select
          onChange={this.handleChange}
          value={commission?.id || ''}
          size='large'
        >
          <Select.Option value={''}>No Commission</Select.Option>
          <Select.Option value={1}>$0.0075 per share</Select.Option>
          <Select.Option value={2}>$1.0 per trade</Select.Option>
          <Select.Option value={3}>$0.0015 per dollar</Select.Option>
        </Select>
      </div>
    )
  }
}

export default Commission
